import * as React from 'react';

// PACKAGES
import { Link } from 'react-router-dom';

// COMPONENTS
import Button from '../../components/Button';
import LoginForm from './LoginForm';

// ICONS
import { ReactComponent as MainLogo } from '../../assets/img/logo-main.svg';
import { ReactComponent as TickCircle } from '../../assets/svg/tick-circle.svg';

// TYPES
import { AccountRegistrationCommand } from '../../api/models';
import { closeModalType } from '../../components/GlobalModal';

interface LoginCreateModalTypes {
	organisationIdentifier?: AccountRegistrationCommand['organisationIdentifier'];
	paymentPlanId?: AccountRegistrationCommand['paymentPlanId'];
	profileType?: AccountRegistrationCommand['profileType'];
	previousUrl?: string;
	returnUrl?: string;
	closeModal?: closeModalType;
}

export const LoginCreateModal: React.FC<LoginCreateModalTypes> = ({
	organisationIdentifier,
	paymentPlanId,
	profileType,
	previousUrl,
	returnUrl = '/dashboard',
	closeModal
}) => {
	return (
		<div className="modal-panel login-create-modal">
			<div className="panel panel-login">
				<div className="header">
					{!!closeModal && (
						<Button className="btn-text" onClick={closeModal}>
							Close
						</Button>
					)}

					<MainLogo className="logo" />

					<h1 className="h3">Log in to your ChildAware account&nbsp;to&nbsp;continue</h1>
				</div>

				<LoginForm
					organisationIdentifier={organisationIdentifier}
					paymentPlanId={paymentPlanId}
					profileType={profileType}
					previousUrl={previousUrl}
					returnUrl={returnUrl}
				/>
			</div>

			<div className="panel panel-create">
				<div className="header">
					{!!closeModal && (
						<Button className="btn-text" onClick={closeModal}>
							Close
						</Button>
					)}

					<h2 className="h3">Don't have an account?</h2>
				</div>

				<div className="content">
					<ul>
						<li>
							<TickCircle /> Quick and easy sign up
						</li>

						<li>
							<TickCircle /> Safe and secure
						</li>

						<li>
							<TickCircle /> Link your account to multiple organisations
						</li>

						<li>
							<TickCircle /> Essential for staff, parents, children, volunteer and visitors
						</li>
					</ul>
				</div>

				<div className="actions">
					<Link
						to={{
							pathname: '/create-account',
							state: {
								organisationIdentifier,
								paymentPlanId,
								profileType,
								previousUrl,
								returnUrl
							}
						}}
						className="btn btn-secondary full-width"
					>
						Create an account
					</Link>
				</div>
			</div>
		</div>
	);
};

export default LoginCreateModal;
